import { Link } from 'react-router-dom';
import { articles } from '@/mocks/homeData';

export default function ArticleSection() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新资讯
            </h2>
            <p className="text-sm text-foreground-500 mt-2">影视圈最新动态与深度分析</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  title={article.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-accent-500 text-background-50 text-xs px-2.5 py-1 rounded-full font-medium">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-base text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-3 leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.views} 阅读
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}